import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TrackingEvent } from '../../enums/tracking-event/tracking-event.enum';
import { TrackingService } from '../tracking/tracking.service';

@Injectable({
    providedIn: 'root',
})
export class PageViewTrackingService {
    #trackingService = inject(TrackingService);
    #router = inject(Router);

    trackPageViewed(pageName: string, product?: string): void {
        this.#trackingService.trackEvent(TrackingEvent.PAGE_VIEWED, {
            page_name: pageName,
            product,
        });
    }

    trackPageLoadFailed(pageName: string, product?: string): void {
        this.#trackingService.trackEvent(TrackingEvent.PAGE_LOAD_FAILED, {
            page_name: pageName,
            url: this.#router.url,
            product,
        });
    }
}
